import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useBrand } from '../../contexts/BrandContext';
const included = ['Your doctor, and a plan written for you', 'A 62-marker blood panel every year', 'Medication from a named US pharmacy', 'Retests and dose changes', 'Free shipping, cold-packed when it needs to be'];
const excluded = ['A dispensing fee bolted on at the end', 'Charges for asking your doctor a question', 'Dose increases you did not agree to', 'Twelve-month contracts and retention calls', 'Grey-market vials with no paperwork'];
export function Transparency() {
  const {
    brand
  } = useBrand();
  return <section className="bg-cream" data-id="element-164" data-mp="9t8ihnr1df9i">
      <div className="mx-auto max-w-shell px-6 py-16 md:px-8 md:py-24" data-id="element-165" data-mp="9s78lmlraytd">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20" data-id="element-166" data-mp="3i8s88csi0fjt">
          <div data-id="element-167" data-mp="3daqorqr5ue7t">
            <p className="text-[0.6875rem] uppercase tracking-label text-brick" data-id="element-168" data-mp="3db8wbjj9wev1">Pricing</p>
            <h2 className="mt-3 max-w-sm font-serif text-3xl font-bold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-169" data-mp="3tu298o2p6h56">
              Why is it this cheap? What is the catch?
            </h2>
            <div className="mt-6 flex flex-col gap-4 text-base leading-relaxed text-ink-soft" data-id="element-170" data-mp="7dftjb74dmeo">
              <p data-id="element-171" data-mp="ccsraqzj4dw1">
                There is not one. Most healthcare companies bury their margin inside the price of
                your medication, so the number moves every time your dose does and you never really
                know what you are paying for.
              </p>
              <p data-id="element-172" data-mp="3fvlz0n5mm8ia">
                {brand.name} splits it in two. $39 a month buys your doctor, your bloodwork and your
                records. The medication is billed at what the pharmacy charges plus a flat handling
                fee we will tell you to your face. Both numbers are locked for twelve months.
              </p>
              <p className="font-serif text-xl font-semibold text-ink" data-id="element-173" data-mp="143gr9zpgvd84">
                Good medicine should not be a luxury good.
              </p>
            </div>
            <Link to="/pricing" className="mt-7 inline-flex rounded-full border border-ink/20 px-5 py-2.5 text-sm text-ink transition-colors duration-150 ease-republic hover:border-ink hover:bg-ink hover:text-cream" data-id="element-174" data-mp="316pbeu4hx0on">
              See every price
            </Link>
          </div>

          <div className="grid gap-6 md:grid-cols-2" data-id="element-175" data-mp="2hgdip646bj66">
            <div className="rounded-brand border border-ink/10 bg-cream-light p-6" data-id="element-176" data-mp="2hh52zksbluh5">
              <h3 className="text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-177" data-mp="2dguy6bg9la3v">
                What you get
              </h3>
              <ul className="mt-5 flex flex-col gap-4" data-id="element-178" data-mp="2mfyifir63vjy">
                {included.map(item => <li key={item} className="flex items-start gap-3" data-id="element-179" data-mp="1yqdz2yr3qwa5">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brick" strokeWidth={2.25} data-id="element-180" data-mp="1yokqvf0uc401" />
                    <span className="text-sm leading-relaxed text-ink-soft" data-id="element-181" data-mp="1tr10jgqvc0rq">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div className="rounded-brand border border-ink/10 bg-cream p-6" data-id="element-182" data-mp="e08m8naiovga">
              <h3 className="text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-183" data-mp="8twlxm3tw09">
                What you will never get
              </h3>
              <ul className="mt-5 flex flex-col gap-4" data-id="element-184" data-mp="586j2h92d12b">
                {excluded.map(item => <li key={item} className="flex items-start gap-3" data-id="element-185" data-mp="sxr8nizq2wkk">
                    <MinusIcon className="mt-0.5 h-4 w-4 shrink-0 text-stone" strokeWidth={2.25} data-id="element-186" data-mp="wz49tfrvebl5" />
                    <span className="text-sm leading-relaxed text-ink-muted" data-id="element-187" data-mp="izuz2vmfo9ok">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}